import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import { Attachment } from "../../Partials/Attachment/Attachment";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { connect } from "react-redux";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { Timeline } from "../../Partials/Timeline/Timeline";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import Formatter from "../../../Localization/Formatter";
import PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import PaymentTypeContainer from "../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import TextField from "../../Partials/Material/TextField";
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Select from "../../Partials/Material/Select";
import CompanyUpdateWillMount from "../../../Middleware/Middlewares/CompanyUpdateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import { FinancialStatementsList } from "../../Partials/FinancialStatement/FinancialStatementsList";
import { SavingsCompanyDialog } from "../../Partials/Dialog/SavingsCompanyDialog";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import AgencyFeeContainer from "../../../Entity/Entities/AgencyFee/AgencyFeeContainer";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { DownloadEntityPrompt } from "../../Partials/Dialog/DownloadEntityPrompt";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { BalanceComponent } from "../../Partials/Balance/BalanceComponent";
import Translator from "../../../Translation/Translator";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import CircularProgress from '@material-ui/core/CircularProgress';
import ChargeCreateDialog from "../../Partials/Dialog/ChargeCreateDialog";
import { UndoSettleWithSavingsDialog } from "../../Partials/Dialog/UndoSettleWithSavingsDialog";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import EntityLaunchpanel from "../../Partials/Launchpanel/EntityLaunchpanel";
import UnitCard from "../../Partials/Unit/UnitCard";
import PropertyCard from "../../Partials/Property/PropertyCard";
import PersonCard from "../../Partials/Person/PersonCard";
import CompanyCard from "../../Partials/Company/CompanyCard";
import PaymentCounterpartyDescriptionInfoForList from "../../Partials/Payment/PaymentCounterpartyDescriptionInfoForList";
import CoachNewCharge from "../../Partials/Dialog/CoachNewCharge";
import { CoachNewUnitDialog } from "../../Partials/Dialog/CoachNewUnitDialog";
import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";


class CompanyUpdate extends Component {
  private selectedPersonForMenu: PersonInterface;
  private selectedProperty: PropertyInterface;
  private selectedPerson: PersonInterface;
  protected savingsPaymentsPaginatorPath: string;
  protected personsPaginatorPath: string;
  protected propertiesPaginatorPath: string;
  protected selectedPayment: PaymentInterface;
  protected searchTimer;

  public state = {
    company: null,
    isDialogOpen: false,
    id: 0,
    name: "",
    shortName: "",
    email: "",
    phone: "",
    mainBankAccountId: "",
    mainBankAccountName: "",
    agencyBankAccountId: "",
    agencyBankAccountName: "",
    companyBankId: "",
    address: {
      formattedAddress: ""
    },
    personFirstName: "",
    amazonFolderName: null,
    openLeavePrompt: false,
    lastActiveTabIndex: Constants.COMPANY_DETAILS_OVERVIEW_TAB,
    isDisabled: true,
    note: "",
    hasModifiedData: false,
    selectedTabIndex: Constants.COMPANY_DETAILS_OVERVIEW_TAB,
    isCreateBankAccountDialogOpen: false,
    isUpdating: false,
    // isAgencyFeeDialogOpen: false,
    beta: false,
    isAgencyRemoveDialog: false,
    agencyFee: null,
    ibanUsedForEntity: null,
    nextPath: "",
    isSaving: false,
    anchorElPersons: null,
    anchorElProperties: null,
    anchorElAgencyFees: null,
    events: [],
    fetchingEvents: true,
    financialStatements: [],
    attachments: [],
    removed: false,
    сreateFromCoach: false,
    propertyCreateDataToBeSaved: {},
    charges: [],
    invoices: [],
    removedPayments: [],
    paymentsFailedToRemove: [],
    deletedCharge: null,
    chargeRemoveSucceedDialogOpen: false,
    anchorCompanyEl: null,
    isDeletePromptOpen: false,
    isDownloadPromptOpen: false,
    openSavingsDialog: false,
    openDepositDialog: false,
    agencyBankAccounts: [],
    bankAccountId: null,
    amountWithdrawal: "",
    savingsPayments: [],
    savingsPaymentsCount: 0,
    isFetching: false,
    anchorElPayment: null,
    isPaymentRemovePopupOpen: false,
    openWithdrawalPreProcessDialog: false,
    isAdmin: false,
    amountDeposit: "",
    cannotDeleteSavingsChargeDialog: false,
    dontCheckLoacationFromStore: false,
    filterValue: "",
    searchInProgress: false,
    generalContactId: null,
    isChargeCreatePopupOpen: false,
    isCoachNewChargeOpen: false,
    savingsType: "",
    isUndoSavingsPopupOpen: false,
    vat: "",
    openCoachCreateNewUnit: false,
    invoiceEmailAddress: '',
    invoiceEmailSubject: '',
    // Default agreement
    fixedFee: "",
    percentageFee: "",
    fixedPlusPercentageMode: this.props.globalTypes?.FixedPlusPercentageModes?.[this.defaultFixedPlusPercentageModes("FPP_both")],
    agreementVat: "",
    vatPercentage: "",
    chargeTypeIds: [TypeContainer.pickIdFromLabel("Basic_rent")],
    repeatPeriod: PeriodContainer.pickIdFromLabel("monthly"),
    assignmentServiceStatus: AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial"),
    currency: this.props.app.settings.user.currency.getCurrencyId(),
    year: "",
    selectedYear: "",
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CONTACT_COMPANY_UPDATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    CompanyUpdateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);

    this.closeDialog = this.closeDialog.bind(this);
    this.savePerson = this.savePerson.bind(this);
    this.openTabDialog = this.openTabDialog.bind(this);
    this.addSelectedPersonToCache = this.addSelectedPersonToCache.bind(this);
    this.removeSelectedPersonFromCache = this.removeSelectedPersonFromCache.bind(this);
    this.addSelectedPersonToState = this.addSelectedPersonToState.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.updatePersonName = this.updatePersonName.bind(this);
    this.save = this.save.bind(this);
    this.done = this.done.bind(this);
    this.switchTab = this.switchTab.bind(this);
    this.renderCompanyInfoTab = this.renderCompanyInfoTab.bind(this);
    this.closePrompt = this.closePrompt.bind(this);
    this.delete = this.delete.bind(this);
  }

  public componentWillUnmount() {
    clearTimeout(this.searchTimer);

    this.props.dispatch({
      type: Constants.SAVINGS_PAYMENTS_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        companyId: this.state.company?.id,
        filter: this.state.filterValue
      }
    });

    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_CLEAR
    });
  }

  public initializePage = (company: CompanyInterface) => {
    if (!company) {
      return this.redirectBack();
    }

    this.savingsPaymentsPaginatorPath = `Savings_for_${company?.id}`;

    const agencyBankAccounts = this.getAgencyBankAccounts();

    if (!this.state.dontCheckLoacationFromStore) {
      if (this.props?.location?.query?.сreateFromCoach) {
        this.setState({
          сreateFromCoach: true,
          company: company,
        })
      }
    }

    this.personsPaginatorPath = `CompanyPersons_${company.id}`;
    this.propertiesPaginatorPath = `CompanyProperties_${company.id}`;

    this.fetchEntityEvents(company.id);
    this.fetchCompanyCharges(company.id);
    this.fetchCompanyInvoices(company.id);

    this.setState({
      filterValue: this.props.app?.savingsPaymentsFilterSearchState?.[company.id]
    }, () => this.fetchSavingsPayments(company.id));

    this.props.dispatch({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
      payload: {
        ownerId: company.id
      },
      onSuccess: data => this.setState({ financialStatements: [...data.financialStatements] })
    });

    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_CLEAR
    });

    let selectedTabIndex = (!company.isOwner && !company.isAgency) ? Constants.COMPANY_DETAILS_OVERVIEW_TAB : this.props.app.companyUpdatePageTabIndex;
    if (company?.id !== this.props.app.selectedСompanyId) {
      selectedTabIndex = Constants.COMPANY_DETAILS_OVERVIEW_TAB;
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_COMPANY_UPDATE_SWITCH_TAB,
        payload: {
          index: Constants.COMPANY_DETAILS_OVERVIEW_TAB
        }
      });
    }
    if (this.props?.location?.query?.savings && this.props?.location?.query?.savings === "true") {
      selectedTabIndex = Constants.COMPANY_DETAILS_SAVINGS_TAB;
    }

    const usingBeta = this.props && this.props.app && this.props.app.settings && this.props.app.settings.user && this.props.app.settings.user.beta;
    const isAdmin = this.props
      && this.props.app
      && this.props.app.session
      && this.props.app.session.user
      && typeof this.props.app.session.user.isAdmin === "function"
      && this.props.app.session.user.isAdmin() === true;


    const agencyFee = company?.defaultAgencyFees[0];
    let vatPercentage = "";

    if (agencyFee && agencyFee.fixedFee) {
      const vatPercentageNumber = Math.round(agencyFee.vat / (agencyFee.fixedFee - agencyFee.vat) * 100);

      if (!isNaN(vatPercentageNumber)) {
        vatPercentage = this.formatter.simpleFormatNumber(vatPercentageNumber, false, false);
      }
    }

    this.setState({
      company: company,
      id: company.id,
      note: company.note,
      name: company.name,
      shortName: company.shortName,
      email: company.email,
      phone: company.phone,
      mainBankAccountId: company.mainBankAccountId,
      mainBankAccountName: company.mainBankAccountName,
      agencyBankAccountId: company.agencyBankAccountId,
      agencyBankAccountName: company.agencyBankAccountName,
      companyBankId: company.companyBankId,
      address: company.address,
      attachments: company.attachments,
      selectedTabIndex: selectedTabIndex,
      beta: usingBeta,
      removed: company.removed,
      agencyBankAccounts: agencyBankAccounts,
      bankAccountId: agencyBankAccounts.find(bankAccount => bankAccount.accountId === company?.mainBankAccountId)?.id || "",
      amountWithdrawal: "",
      isAdmin: isAdmin,
      generalContactId: company?.generalContactId,
      vat: company?.vat,
      invoiceEmailAddress: company.invoiceEmailAddress,
      invoiceEmailSubject: company.invoiceEmailSubject,
      selectedAgencyFee: company?.defaultAgencyFees[0],
      agencyFee: agencyFee,
      currency: agencyFee ? agencyFee.currency.getCurrencyId() : this.props.app.settings.user.currency.getCurrencyId(),
      fixedFee: agencyFee && ((!agencyFee.fixedFee && agencyFee.fixedFee !== 0) ? "" : this.formatter.simpleFormatNumber(agencyFee.fixedFee)),
      percentageFee: agencyFee ? this.formatter.simpleFormatNumber(agencyFee?.percentageFee, false) : "",
      fixedPlusPercentageMode: agencyFee ? agencyFee.fixedPlusPercentageMode : this.props.globalTypes?.FixedPlusPercentageModes?.[this.defaultFixedPlusPercentageModes("FPP_both")],
      agreementVat: agencyFee ? (!agencyFee.vat ? "" : this.formatter.simpleFormatNumber(agencyFee.vat)) : "",
      vatPercentage: vatPercentage ? vatPercentage : "",
      chargeTypeIds: agencyFee?.chargeTypeIds || [TypeContainer.pickIdFromLabel("Basic_rent")],
      repeatPeriod: agencyFee?.repeatPeriod ? agencyFee?.repeatPeriod : PeriodContainer.pickIdFromLabel("monthly"),
      assignmentServiceStatus: agencyFee?.assignmentServiceStatus,
      isConcept: agencyFee?.isConcept,
      agreementRemoved: agencyFee?.removed
    });

    if (Object.keys(this.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdPerson = this.props.app.savedDataBeforeRedirecting.createdPerson &&
        this.props.app.savedDataBeforeRedirecting.createdPerson;

      if (typeof createdPerson !== "undefined") {
        this.selectedPerson = createdPerson;
      }

      if (this.props?.location?.query?.сreateFromCoach) {
        this.setState({
          propertyCreateDataToBeSaved: this.props.app.savedDataBeforeRedirecting.propertyCreateDataToBeSaved
        })
      }

      this.setState({ ...this.props.app.savedDataBeforeRedirecting.companyUpdateDataToBeSaved }, () => {
        this.props.dispatch({
          type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
        });
      });
    }
  }

  public componentWillReceiveProps(nextProps) {

    const prevId = parseInt(this.props.params.id, 10);
    const id = parseInt(nextProps.params.id, 10);
    const company = nextProps.app.companies.filter(
      (company: CompanyInterface) => company.id === id
    )[0];


    if (nextProps?.location?.query?.сreateFromCoach) {
      this.setState({
        сreateFromCoach: true,
        company: company,
      })
    }

    if (prevId !== id) {
      this.setState({
        dontCheckLoacationFromStore: true //need this hack, because if we are on page company update and after this click on global search or breadscrumbs to open other company, in Initialize we use this props location but there we have old path.
      }, () => {
        this.initializePage(company);
      })

    } else {
      this.setState({
        company: company,
        amountWithdrawal: "",
        attachments: !!company ? company.attachments : []
      });
    }
  }

  public defaultFixedPlusPercentageModes(label) {
    const chargeClass = this.props.globalTypes?.FixedPlusPercentageModes;
    for (const key in chargeClass) {
      if (chargeClass[key].label === label) {
        return chargeClass[key].id
      }
    }
  }

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        companyId: entityId
      },
      onSuccess: data => {
        const companyEvents: EventInterface[] = data.events
          .filter((event: EventInterface) => !event.removed);

        this.setState({
          events: [...companyEvents],
          fetchingEvents: false
        });
      }
    });
  }

  public fetchCompanyCharges = (companyId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ownerId: companyId,
        isAfterStartDate: 1, // do not fetch charges before start date
      },
      onSuccess: data => {
        this.setState({ charges: [...data.charges] });
      }
    });
  }
  public fetchCompanyInvoices = (companyId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ownerId: companyId,
        isAfterStartDate: 1, // do not fetch charges before start date
        invoiceNumber: true,
        agencyOnly: false,
      },
      onSuccess: data => {
        this.setState({ invoices: [...data.charges] });
      }
    });
  }

  public deleteCharge = (charge: ChargeInterface): any => {
    if (charge?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_withdraw") || charge?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_deposit")) {
      return this.setState({
        isChargeRemovePopupOpen: false,
        cannotDeleteSavingsChargeDialog: true
      });
    }

    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_DELETE_START,
        payload: {
          charge: charge
        },
        onSuccess: res => {
          this.fetchCompanyCharges(this.state.company.id);

          this.setState({
            deletedCharge: charge,
            removedPayments: res.data.data.removedPayments,
            paymentsFailedToRemove: res.data.data.paymentsFailedToRemove,
            isSaving: false
          }, () => {
            if (this.state.deletedCharge && this.state.deletedCharge.amountPaid > 0 && this.state.removedPayments.length === 0) {
              this.setState({
                chargeRemoveSucceedDialogOpen: true
              });
            }
          });
        }
      });
    });
  }

  public updatePersonName(event: any): any {
    this.sync(this.syncronizers.EVENT, "personFirstName", event);

    if (event.currentTarget.value.length === 0) {
      this.setState({
        isDisabled: true
      });
      return;
    }

    this.setState({
      isDisabled: false
    });
  }

  public addSelectedPersonToCache = (person: PersonInterface) => {
    this.selectedPerson = person;

    this.setState({
      isDisabled: false
    });
  }

  public removeSelectedPersonFromCache = () => {
    this.selectedPerson = null;

    (this.refs.PersonLookup as any) && (this.refs.PersonLookup as any).refs.instance.clear();

    this.setState({
      isDisabled: true
    });
  }

  public changeGeneralContact = (person: PersonInterface, isManuallySelected: boolean) => {
    this.setState({
      generalContactId: person?.id,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData
    });
  }

  public clearGeneralContact = () => {
    this.setState({
      generalContactId: null,
      hasModifiedData: true
    });
  }

  public addSelectedPersonToState = () => {
    // If selected person is null, then we created a person.
    if (!this.selectedPerson) {
      this.props.dispatch({
        type: Constants.GLOBAL_COMPANY_ADD_PERSON_AFTER_CREATING,
        payload: {
          id: this.state.id,
          person: {
            firstName: this.state.personFirstName
          }
        },
        onSuccess: () => {
          this.setState({
            hasModifiedData: false
          });
        }
      });
    } else if (this.state.lastActiveTabIndex === Constants.COMPANY_DETAILS_CHARGES_TAB && this.state.personFirstName !== "") {
      /*
      |  However, if there is a selectedPerson and both personFirstName
      |  we need to give priority depending on last active tab.
      */
      this.props.dispatch({
        type: Constants.GLOBAL_COMPANY_ADD_PERSON_AFTER_CREATING,
        payload: {
          id: this.state.id,
          person: {
            firstName: this.state.personFirstName
          }
        },
        onSuccess: () => {
          this.setState({
            hasModifiedData: false
          });
        }
      });
    } else {
      // Add the selected person to the array
      this.props.dispatch({
        type: Constants.GLOBAL_COMPANY_ADD_PERSON,
        payload: {
          id: this.state.id,
          person: this.selectedPerson,
          companyIds: [{ id: this.state.id, role: "" }]
        },
        onSuccess: () => {
          this.setState({
            hasModifiedData: false
          });
        }
      });
    }

    // Remove selected person
    this.selectedPerson = null;
    this.closeDialog();
  }

  public save() {
    // In this page, we save default agency fee.
    if (this.state.selectedTabIndex === Constants.COMPANY_DETAILS_SETTINGS_TAB) {
      this.setState({
        isSaving: true
      })

      this.props.dispatch({
        type: Constants.PAGE_CONTACT_COMPANY_UPDATE_START,
        payload: {
          id: this.state.id,
          company: {
            name: this.state.name,
            shortName: this.state.shortName,
            email: this.state.email,
            phone: this.state.phone,
            mainBankAccountId: this.state.mainBankAccountId,
            mainBankAccountName: this.state.mainBankAccountName,
            bankAccount: {
              accountId: this.state.mainBankAccountId,
              name: this.state.mainBankAccountName
            },
            companyBankId: this.state.companyBankId,
            address: Object.keys(this.state.address || {}).length > 0 ? { ...this.state.address } : null,
            note: this.state.note,
            generalContactId: this.state.generalContactId,
            vat: this.state.vat,
            invoiceEmailAddress: this.state.invoiceEmailAddress,
            invoiceEmailSubject: this.state.invoiceEmailSubject,
          }
        },
        onSuccess: () => {
          this.setState({ isSaving: false })
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });

      const payload = {
        id: this.state.agencyFee?.id,
        objectType: this.state.agencyFee ? this.state.agencyFee?.objectType : AgencyFeeContainer.pickIdFromLabel("Agency"),
        objectId: this.state.agencyFee ? this.state.agencyFee?.objectId : this.state.company.id,
        currency: this.state.currency,
        fixedFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2)),
        percentageFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.percentageFee)).replace(",", ".")).toFixed(2)),
        vat: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state?.agreementVat)).replace(",", ".")).toFixed(2)),
        fixedPlusPercentageMode: this.state.fixedPlusPercentageMode?.id,
        chargeTypeIds: this.state.chargeTypeIds,
        repeatPeriodId: this.state.repeatPeriod,
        serviceStatusId: this.state.assignmentServiceStatus,
      };
      if (payload.id) {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.GLOBAL_AGENCY_FEE_UPDATE_DEFAULT_START,
            payload: {
              ...payload
            },
            onSuccess: (agencyFee: AgencyFeeInterface) => {
              this.setState({
                hasModifiedData: false,
                isSaving: false,
                agencyFee: agencyFee
              })
            },
            onError: () => {
              this.setState({
                hasModifiedData: true,
                isSaving: false
              })
            }
          });
        });
      } else {
        delete payload.id;
        this.props.dispatch({
          type: Constants.GLOBAL_AGENCY_FEE_CREATE_DEFAULT_START,
          payload: payload,
          onSuccess: (agencyFee: AgencyFeeInterface) => {
            this.setState({
              hasModifiedData: false,
              isSaving: false,
              agencyFee: agencyFee
            })
          },
          onError: () => {
            this.setState({
              hasModifiedData: true,
              isSaving: false
            })
          }
        });
      }
    } else {
      const iban = this.state.company?.isAgency ? this.state.agencyBankAccountId : this.state.mainBankAccountId;

      if (iban) {
        const company: CompanyInterface = this.props.app.companies.find((company: CompanyInterface) => company.mainBankAccountId === this.state.mainBankAccountId);
        const person: PersonInterface = this.props.app.persons.find((person: PersonInterface) => person.mainBankAccountId === this.state.mainBankAccountId);
        if (!!person) {
          this.setState({
            ibanUsedForEntity: person
          });
        }

        if (!!company) {
          this.setState({
            ibanUsedForEntity: company
          });
        }
      }

      this.saving(() => {
        return this.props.dispatch({
          type: Constants.PAGE_CONTACT_COMPANY_UPDATE_START,
          payload: {
            id: this.state.id,
            company: {
              name: this.state.name,
              shortName: this.state.shortName,
              email: this.state.email,
              phone: this.state.phone,
              mainBankAccountId: this.state.mainBankAccountId,
              mainBankAccountName: this.state.mainBankAccountName,
              bankAccount: {
                accountId: this.state.mainBankAccountId,
                name: this.state.mainBankAccountName
              },
              companyBankId: this.state.companyBankId,
              address: Object.keys(this.state.address || {}).length > 0 ? { ...this.state.address } : null,
              note: this.state.note,
              generalContactId: this.state.generalContactId,
              vat: this.state.vat,
              invoiceEmailAddress: this.state.invoiceEmailAddress,
              invoiceEmailSubject: this.state.invoiceEmailSubject,
            }
          },
          onSuccess: (company) => {
            this.setState({ isSaving: false }, () => {
              if (this.state.nextPath) {
                return this.redirect(this.state.nextPath);
              }

              this.redirectBackModify(company);
            })
          },
          onError: () => {
            this.setState({
              isSaving: false,
              hasModifiedData: true
            });
          }
        });
      });
    }
  }
  public unlinkPerson = (person: PersonInterface): any => {
    const companies = person?.companies?.filter(company => company?.id !== this.state.company?.id);

    // Remove the person from the relations.
    this.props.dispatch({
      type: Constants.GLOBAL_COMPANY_UNLINK_PERSON_START,
      payload: {
        companyIds: companies?.map(company => {
          return { id: company?.id, role: company?.contactsForCompanies?.role }
        }),
        companyId: this.state.company?.id,
        person: person
      },
      onError: err => {
        if (err?.errorId === "cannot_change_generalContactId_if_company_is_tenant") {
          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("cannot_change_generalContactId_if_company_is_tenant"),
              type: "error"
            }
          });
        }
      }
    });
  }

  public savePerson(person: PersonInterface): any {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_PERSON_UPDATE_START,
      payload: {
        id: person.id,
        isFromDialog: true,
        person: {
          firstName: person.firstName,
          lastName: person.lastName,
          profession: person.profession,
          email: person.email,
          phone1: person.phone1,
          phone2: person.phone2,
          contactRoleId: person.role,
          companyId: person.companyId,
          address: {
            ...person.address
          },
          note: person.note
        }
      },
      onSuccess: () => {
        this.closeDialog();
      },
      onError: () => {
        this.closeDialog();
      }
    });
  }

  public openTabDialog() {
    this.setState({
      isDialogOpen: true
    }, () => {
      setTimeout(() => {
        (this.refs.PersonLookup as any) && (this.refs.PersonLookup as any).refs.instance.ref.focus();
      }, 10);
    });
  }

  public closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      personFirstName: "",
      lastActiveTabIndex: Constants.COMPANY_DETAILS_OVERVIEW_TAB
    });

    this.selectedPerson = undefined;
  }

  protected openMenuPersons = (event: any, person: PersonInterface): void => {
    this.selectedPersonForMenu = person;

    this.setState({
      anchorElPersons: event.currentTarget
    });
  }

  protected closeMenuPersons = (): void => {
    this.setState({
      anchorElPersons: null
    });
  }

  protected openMenuProperties = (event: any, property: PropertyInterface): void => {
    this.selectedProperty = property;

    this.setState({
      anchorElProperties: event.currentTarget
    });
  }

  protected closeMenuProperties = (): void => {
    this.setState({
      anchorElProperties: null
    });
  }

  // protected openMenuAgencyFees = (event: any, agencyFee: AgencyFeeInterface): void => {
  //   this.selectedAgencyFee = agencyFee;

  //   this.setState({
  //     anchorElAgencyFees: event.currentTarget
  //   });
  // }

  protected closeMenuAgencyFees = (): void => {
    this.setState({
      anchorElAgencyFees: null
    });
  }

  public getPersons() {
    return this.state.company && this.state.company.persons
      .filter((person: PersonInterface) => !!person)
      .sort((person1: PersonInterface, person2: PersonInterface) => {
        if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` > `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
          return 1;
        }

        if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` < `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
          return -1;
        }

        return 0;
      })
      .map((person: PersonInterface) => {
        return (
          <TableRow
            hover
            key={`person-${person.id}`}
            className={`clickable-entity`}
            onClick={() => {
              this.state?.company?.isAgency ?
                this.redirect(`/app/user/update/${person.id}`) :
                this.redirect(`/app/person/update/${person.id}`);
            }}
          >
            <TableCell>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "40px", marginBottom: "2px" }}>
                {person.renderAvatar()}
              </div>
            </TableCell>
            <TableCell>{person.displayName}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenuPersons(e, person)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElPersons}
                  open={Boolean(this.state.anchorElPersons) && this.selectedPersonForMenu && this.selectedPersonForMenu.id === person.id}
                  onClose={this.closeMenuPersons}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                    onClick={() => this.redirect(`/app/person/update/${this.selectedPersonForMenu.id}/${this.state.id}`)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                    className="delete-action"
                    onClick={() => this.unlinkPerson(this.selectedPersonForMenu)}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  protected propertyDelete(property: PropertyInterface) {
    this.closeMenuProperties();

    this.props.dispatch({
      type: Constants.PAGE_PROPERTY_DELETE_START,
      payload: {
        property: property
      }
    });
  }

  public getProperties() {
    return this.state.company && this.state.company.properties
      .filter((property: PropertyInterface) => property.removed === false)
      .map((property: PropertyInterface) => {
        if (!property) {
          return;
        }

        return (
          <TableRow
            hover
            key={`property-${property.id}`}
            className={`clickable-entity`}
            onClick={() => {
              this.redirect(`/app/property/update/${property.id}`);
            }}
          >
            <TableCell>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "40px", marginBottom: "2px" }}>
                {property.renderAvatar()}
              </div>
            </TableCell>
            <TableCell>{property.address.formattedAddress}</TableCell>
            <TableCell>{this.trans("title-units-amount", { amount: property.units.length })}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenuProperties(e, property)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElProperties}
                  open={Boolean(this.state.anchorElProperties) && this.selectedProperty && this.selectedProperty.id === property.id}
                  onClose={this.closeMenuProperties}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                    onClick={() => this.redirect(`/app/property/update/${this.selectedProperty.id}`)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                    className="delete-action"
                    onClick={() => this.propertyDelete(this.selectedProperty)}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  protected onEnter(event): any {
    if (event.key === "Enter") {
      return this.addSelectedPersonToState();
    }
  }

  public switchToTab(index: number): any {
    this.setState({
      lastActiveTabIndex: index,
      personFirstName: "",
      isDisabled: true
    });

    this.removeSelectedPersonFromCache();
  }

  public done(): void {
    this.cancel.bind(this, {
      type: Constants.PAGE_CONTACTS_SWITCH_TAB,
      payload: {
        index: 1
      }
    });

    this.redirectBackModify(this.state.company)
  }

  public handleCreatedPerson = person => {
    this.selectedPerson = person;
  }

  public createNewProperty = (): void => {
    this.props.dispatch({
      type: Constants.PAGE_PROPERTY_CREATE_ADD_PARAMS,
      payload: {
        owner: this.state.company
      }
    });

    this.redirect(`/app/property/create/${this.state.company?.id}`);
  }

  public saveScrollPosition = () => {
    var top = window.pageYOffset || document.documentElement.scrollTop;

    this.props.dispatch({
      type: Constants.SAVINGS_PAYMENTS_LIST_POSITION_SAVE,
      payload: {
        position: top
      }
    });
  }

  public fetchSavingsPayments = (companyId): void => {
    this.setState({ isFetching: true }, () => {
      const payload: any = {
        removed: 0,
        type: PaymentTypeContainer.pickIdFromLabel("Savings_account"),
        companyId: companyId,
        filterValue: this.state.filterValue,
      };

      return this.props.dispatch({
        type: Constants.GLOBAL_PAYMENTS_NOT_SAVE_LIST,
        payload: { ...payload },
        onSuccess: (data) => {
          this.setState({
            searchInProgress: false,
            savingsPayments: data.payments,
            isFetching: false
          })
        },
        onError: () => {
          this.setState({
            searchInProgress: false,
            isFetching: false
          });
        }
      })
    });
  }

  protected openMenu = (event: any, payment: PaymentInterface): void => {
    this.selectedPayment = payment;

    this.setState({
      anchorElPayment: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorElPayment: null
    })
  }

  public renderPaymentAmountHint = (payment: PaymentInterface) => {
    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {payment?.getPaymentAmountHint()}
      </span>
    );
  }

  public getPayments = () => {
    return this.state.savingsPayments
      .map((payment: PaymentInterface, index: number) => {
        if (!payment) {
          return;
        }

        let color = "#43A047";

        if (payment.amountUsed < payment.amount) {
          if (payment.amountUsed === 0) {
            color = "#F44336";
          } else {
            color = "#F5A623";
          }
        }

        return (
          <TableRow
            hover
            key={`payment-${index}`}
            className={`clickable-entity`}
            onClick={() => {
              this.saveScrollPosition();

              this.redirect(`/app/payment/update/${payment.id}`);
            }}
          >
            <TableCell style={{ width: "24px", paddingLeft: "24px", paddingRight: "5px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px" }}>
                <div
                  style={{ color: color }}
                  className="icon icon-ic-payment"
                ></div>
              </div>
            </TableCell>
            <TableCell style={{ width: "15%" }}>{this.formatter.formatDate(payment.dateOfThePayment)}</TableCell>
            <TableCell style={{ width: "50%", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "300px" }}>
              <PaymentCounterpartyDescriptionInfoForList payment={payment} />
            </TableCell>
            <TableCell>
              {payment.paymentListTypeLabel() && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column"
                  }}
                >
                  <div className={`list-label creation-type-label ${payment?.creationType?.id === 2 && "red"}`}>
                    {payment.paymentListTypeLabel()}
                  </div>
                </div>
              )}
            </TableCell>
            <TableCell style={{ textAlign: "right", width: "25%" }}>
              <div style={{ display: "inline-flex", flexDirection: "column" }}>
                <span>{payment.paymentClass.id == PaymentClassContainer.pickIdFromLabel("Payable") && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(payment.amount, payment.currency)}</span>
                {this.renderPaymentAmountHint(payment)}
              </div>
            </TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, payment)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElPayment}
                  open={Boolean(this.state.anchorElPayment) && this.selectedPayment && this.selectedPayment.id === payment.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    button
                    key={`add-remove-btn`}
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                        action: "remove",
                        entityName: "payment",
                        entity: this.selectedPayment
                      })) {
                        this.openIsBusyPopup();
                        this.setState({ anchorEl: null })
                      } else {
                        this.setState({
                          isUndoSavingsPopupOpen: true,
                          anchorEl: null
                        })
                      }
                    }
                    }
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-undo-settle-with-savings")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public renderCompanyInfoTab() {
    const actions = [(
      <Button
        key="modal-cancel-btn"
        color="primary"
        onClick={this.closeDialog}
      >
        {this.trans("button-cancel")}
      </Button>
    ),
    (
      <Button
        key="modal-add-btn"
        variant="contained"
        color="primary"
        disabled={this.state.isDisabled || this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
        onClick={this.addSelectedPersonToState}
      >
        {this.trans("button-add")}
      </Button>
    )];

    return (
      <div>
        <div className="component" style={{ boxShadow: "0 3px 6px 0 rgb(0 0 0 / 10%)" }}>
          <CompanyCard
            {...this.props}
            key={`companycard-${this.state.company?.id}`}
            company={this.state.company}
            mainCardPresentation={true}
            editableFields={
              <div className="no-margins has-margin-bottom">
                <Card className="card">
                  <div style={{ maxWidth: "420px" }}>
                    <form>
                      <TextField
                        autoComplete="off"
                        // id="name"
                        // name="name"
                        className="form-element full-size scroll-to-name"
                        type="text"
                        label={this.trans("label-company-name")}
                        value={this.state.name}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "name")}
                        autoFocus={true}
                        disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                        variant="standard"
                        error={!!this.getErrorFor("name")}
                        helperText={this.getErrorFor("name")}
                      />

                      {
                        this.state.company?.isAgency && (
                          <React.Fragment>
                            <TextField
                              autoComplete="off"
                              className="form-element full-size scroll-to-name"
                              type="text"
                              label={this.trans("label-short-name")}
                              value={this.state.shortName}
                              onChange={e => {
                                const shortName = e.target.value;

                                // maxLength === 11 because twilio support only 11 symbols for sender name  
                                if (shortName.length > 11) {
                                  return;
                                }

                                this.setState({
                                  shortName: shortName
                                });
                              }}
                              variant="standard"
                              error={!!this.getErrorFor("shortName")}
                              disabled={!this.state.isAdmin}
                            />
                            {!!this.getErrorFor("shortName") && <div className="component-error-text">{this.getErrorFor("shortName")}</div>}
                            <div className="hint-styles-wrapper">
                              <span className="hint-styles">{this.trans("hint-agency-short-name")}</span>
                            </div>
                          </React.Fragment>
                        )
                      }

                      <AddressSelector
                        {...this.props}
                        id="address"
                        name="address.googlePlaceId"
                        className="scroll-to-address"
                        searchText={this.state.address.formattedAddress ? this.state.address.formattedAddress : null}
                        selectedAddress={this.state.address}
                        onSelect={this.sync.bind(this, this.syncronizers.VALUE, "address")}
                        onClear={this.sync.bind(this, this.syncronizers.VALUE, "address", {})}
                        disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                      />

                      {/* <TextField
                          autoComplete="off"
                          // id="email"
                          // name="email"
                          className="form-element full-size scroll-to-email"
                          type="text"
                          label={this.trans("label-email") + this.trans("field/optional")}
                          value={this.state.email}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
                          disabled={this.state.removed}
                          variant="standard"
                          error={!!this.getErrorFor("email")}
                          helperText={this.getErrorFor("email")}
                        />
                      */}

                      <div style={{ margin: "-14px 0" }}>
                        <PersonLookup
                          {...this.props}
                          className="form-element full-size scroll-to-generalContactId"
                          autoFocus={false}
                          autoSelectId={this.state.generalContactId ? this.state.generalContactId : null}
                          isInlineBlock={true}
                          width="100%"
                          containerWidth="100%"
                          ref="PersonLookup"
                          floatingLabelText={this.state.company?.isAgency ? this.trans("label/agency-general-contact") : this.trans("label/company-general-contact")}
                          labelText={this.state.company?.isAgency ? this.trans("label/agency-general-contact") : this.trans("label/company-general-contact")}
                          onSelect={this.changeGeneralContact}
                          onClear={this.clearGeneralContact}
                          forceUpdatePage={true}
                          onlyUsers={this.state.company?.isAgency ? true : false}
                          disableEntityCreation={true}
                          disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                          error={this.getErrorFor("generalContactId")}
                          entitiesToSearch={this.state.company?.persons}
                        />
                      </div>

                      <TextField
                        autoComplete="off"
                        // id="phone"
                        // name="phone"
                        className="form-element full-size scroll-to-phone"
                        type="text"
                        label={this.trans("phone") + this.trans("field/optional")}
                        value={this.state.phone}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone")}
                        disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                        variant="standard"
                        error={!!this.getErrorFor("phone")}
                        helperText={this.getErrorFor("phone")}
                      />

                      <TextField
                        autoComplete="off"
                        // id="mainBankAccountId"
                        // name="mainBankAccountId"
                        className="form-element full-size scroll-to-mainBankAccountId"
                        type="text"
                        label={this.trans("label-bank-account-id") + this.trans("field/optional")}
                        value={this.state.company?.isAgency ? this.state.agencyBankAccountId : this.state.mainBankAccountId}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, this.state.company?.isAgency ? "agencyBankAccountId" : "mainBankAccountId")}
                        disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                        variant="standard"
                        error={!!this.getErrorFor("createData.bankAccount.accountId")}
                        helperText={this.getErrorFor("createData.bankAccount.accountId")}
                      />

                      <TextField
                        autoComplete="off"
                        // id="mainBankAccountName"
                        // name="mainBankAccountName"
                        className="form-element full-size scroll-to-mainBankAccountName"
                        type="text"
                        label={this.trans("label-bank-account-name") + this.trans("field/optional")}
                        value={this.state.mainBankAccountName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountName")}
                        disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                        variant="standard"
                        error={!!this.getErrorFor("mainBankAccountName")}
                        helperText={this.getErrorFor("mainBankAccountName")}
                      />

                      <TextField
                        autoComplete="off"
                        // id="vat"
                        // name="vat"
                        className="form-element full-size scroll-to-vat"
                        type="text"
                        label={this.trans("label-vat-number") + this.trans("field/optional")}
                        value={this.state.vat}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "vat")}
                        variant="standard"
                        error={!!this.getErrorFor("vat")}
                        helperText={this.getErrorFor("vat")}
                      />

                      <TextField
                        autoComplete="off"
                        id="note"
                        name="note"
                        className="form-element full-size scroll-to-note"
                        type="text"
                        multiline={true}
                        rowsMax={10}
                        label={this.trans("note") + this.trans("field/optional")}
                        value={this.state.note}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                        disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                        variant="standard"
                        error={!!this.getErrorFor("note")}
                        helperText={this.getErrorFor("note")}
                      />
                    </form>
                  </div>
                </Card>
              </div>
            }
          />
        </div>

        {
          !this.state.company?.isAgency && (
            <div className="component-wrapper no-margins has-margin-bottom has-margin-top no-shadow">
              <Card className="card no-padding">
                <div>
                  <div>
                    {
                      this.state.company?.persons
                        .filter((person: PersonInterface) => !!person)
                        .sort((person1: PersonInterface, person2: PersonInterface) => {
                          if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` > `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
                            return 1;
                          }

                          if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` < `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
                            return -1;
                          }

                          return 0;
                        })
                        .map((person: PersonInterface) => {
                          return (
                            <div className="component-wrapper no-margins has-margin-bottom">
                              <div className="component">
                                <PersonCard
                                  {...this.props}
                                  key={`person-${person?.id}`}
                                  person={person}
                                  removePerson={this.unlinkPerson}
                                />
                              </div>
                            </div>
                          );
                        })
                    }
                  </div>
                </div>
              </Card>

              <PromptDialog
                {...this.props}
                title={this.trans("person-pick")}
                innerDialogClasses="person-pick"
                content={
                  <div>
                    <PersonLookup
                      {...this.props}
                      autoFocus={false}
                      autoSelectId={this.selectedPerson ? this.selectedPerson.id : null}
                      isInlineBlock={true}
                      width="100%"
                      containerWidth="100%"
                      ref="PersonLookup"
                      onSelect={this.addSelectedPersonToCache}
                      onClear={this.removeSelectedPersonFromCache}
                      hideClickThroughLink={true}
                      forceUpdatePage={true}
                      saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "companyUpdate")}
                      filterOutEntities={this.state.company && this.state.company.persons}
                      styleInModal={"styleInModal"}
                    />
                  </div>
                }
                openLeavePrompt={this.state.isDialogOpen}
                onClose={this.closeDialog}
                onlyPositiveButton={true}
                crossButtonClose={true}
                prioritizeClosing={true}
                withoutDefaultDilaogButtons={false}
                actions={actions}
              />
            </div>
          )
        }

        <div className="component-wrapper no-margins has-margin-bottom no-shadow">
          <Card className="card no-padding">
            {
              this.state.company?.units
                .filter((unit: UnitInterface) => !unit?.removed)
                .map((unit: UnitInterface) => {
                  return (
                    <div className="component-wrapper no-margins has-margin-bottom">
                      <div className="component">
                        <UnitCard
                          key={`unit-${unit?.id}`}
                          unit={unit}
                        />
                      </div>
                    </div>
                  );
                })
            }
            {
              this.state.company?.properties
                .filter((property: PropertyInterface) => !property?.removed && !property?.units?.length)
                .map((property: PropertyInterface) => {
                  return (
                    <div className="component-wrapper no-margins has-margin-bottom">
                      <div className="component">
                        <PropertyCard
                          key={`property-${property?.id}`}
                          property={property}
                        />
                      </div>
                    </div>
                  );
                })
            }
          </Card>
        </div>

        <div className="component-wrapper no-margins">
          <Attachment
            {...this.props}
            typeOfComponent="shared"
            possibilityToSetAvatar={true}
            title={this.state.company?.isOwner ? this.trans("attachments-for-owner") :
              this.state.company?.isAgency ? this.trans("attachments-for-agency") :
                this.trans("attachments-for-company")}
            amazonFolderName={this.state.amazonFolderName}
            relation="companyId"
            entity={this.state.company}
            attachments={this.state.attachments}
            updateParentState={attachments => this.setState({ attachments: attachments })}
            onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
            onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
            disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
          />
        </div>
      </div>
    );
  }

  public renderChargesTab() {
    return (
      <div>
        <div className="component-wrapper no-margins has-margin-bottom">
          <Card className="card no-padding">
            <div className="label-container">
              <h3 className="card-title">
                {this.trans("balance-for-company")}
              </h3>

              <Button
                color="primary"
                onClick={() => {
                  if (this.checkProcessIsBusy({
                    action: "create",
                    entityName: "charge",
                    entity: this.state.company
                  })) {
                    this.openIsBusyPopup();
                  } else {
                    this.props.dispatch({
                      type: Constants.PAGE_CHARGE_CREATE_ADD_PARAMS,
                      payload: {
                        companyId: this.state.company && this.state.company.id
                      }
                    });

                    // this.openChargeCreatePopup();
                    this.setState({
                      isCoachNewChargeOpen: true
                    });
                  }
                }}
                disabled={this.state.removed}
              >
                {this.trans("button-add-charge")}
              </Button>
            </div>

            <BalanceComponent
              {...this.props}
              balanceFor="company"
              balanceCharges={this.state.charges}
              deleteCharge={this.deleteCharge}
              fetchCharges={() => {
                this.fetchCompanyCharges(this.state.company && this.state.company.id);
              }}
              companyId={this.state.company && this.state.company.id}
            />
          </Card>
        </div>
      </div>
    );
  }
  public renderInvoicesTab() {
    return (
      <div>
        <div className="component-wrapper no-margins has-margin-bottom">
          <Card className="card no-padding">
            {/* <div className="label-container">
              <h3 className="card-title">
                {this.trans("balance-for-company")}
              </h3>

              <Button
                color="primary"
                onClick={() => {
                  if (this.checkProcessIsBusy({
                    action: "create",
                    entityName: "charge",
                    entity: this.state.company
                  })) {
                    this.openIsBusyPopup();
                  } else {
                    this.props.dispatch({
                      type: Constants.PAGE_CHARGE_CREATE_ADD_PARAMS,
                      payload: {
                        companyId: this.state.company && this.state.company.id
                      }
                    });

                    // this.openChargeCreatePopup();
                    this.setState({
                      isCoachNewChargeOpen: true
                    });
                  }
                }}
                disabled={this.state.removed}
              >
                {this.trans("button-add-charge")}
              </Button>
            </div> */}


            <BalanceComponent
              {...this.props}
              invoices={true}
              balanceFor="company"
              balanceCharges={this.state.invoices}
              fetchCharges={() => {
                this.fetchCompanyInvoices(this.state.company && this.state.company.id);
              }}
              companyId={this.state.company && this.state.company.id}
            />
          </Card>
        </div>
      </div>
    );
  }
  public renderStatementsTab() {
    return (
      <div>
        {
          this.state.company?.isOwner && (
            <div className="component-wrapper no-margins">
              <Card className="card no-padding">
                <div className="label-container">
                  <h3 className="card-title">
                    {this.trans("title-statements")}
                  </h3>
                </div>

                <FinancialStatementsList
                  {...this.props}
                  id={this.state.company && this.state.company.id}
                  financialStatements={this.state.financialStatements}
                />
              </Card>
            </div>
          )
        }
      </div>
    );
  }

  public clearFilterValue = () => {
    this.props.dispatch({
      type: Constants.SAVINGS_PAYMENTS_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        companyId: this.state.company?.id,
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, () => this.fetchSavingsPayments(this.state.company?.id));
  }

  public setFilterValue = (event): any => {
    clearTimeout(this.searchTimer);

    this.setState({
      filterValue: event.target.value
    }, () => {
      if (this.state.filterValue === "") {
        return this.clearFilterValue();
      }

      this.props.dispatch({
        type: Constants.SAVINGS_PAYMENTS_FILTER_SEARCH_UPDATE_STATE,
        payload: {
          companyId: this.state.company?.id,
          filter: this.state.filterValue
        }
      });

      this.searchTimer = setTimeout(() => {
        this.setState({
          searchInProgress: true
        }, () => {
          this.fetchSavingsPayments(this.state.company?.id);
        });
      }, this.props.app?.listSearchTimeout);
    });
  }

  public renderSavingsTab() {
    return (
      <div>
        <div className="component-wrapper no-margins has-margin-bottom" style={{ padding: "15px 10px 15px 65px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            {Translator.transJSX("label-total", {
              amount: <span style={{ fontWeight: "bold" }}>{this.formatter.formatNumber(this.state?.company?.savingsAccount, this.props.app.settings.user.currency)}</span>
            })}
          </div>
          <div>
            {
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  if (this.checkProcessIsBusy({
                    action: "withdraw",
                    entityName: "company",
                    entity: this.state.company
                  })) {
                    this.openIsBusyPopup();
                  } else {
                    this.setState({
                      openSavingsDialog: true,
                      savingsType: "withdrawal",
                      amountWithdrawal: this.state.company?.savingsAccount && Math.sign(this.state.company?.savingsAccount) !== -1 ? Formatter.simpleFormatNumber(this.state.company?.savingsAccount) : ""
                    })
                  }
                }}
                disabled={this.state.removed || this.state.company?.savingsAccount < 0}
              >
                {this.trans("button-withdrawal")}
              </Button>
            }
          </div>
        </div>

        {
          (this.state.savingsPayments?.length > 0 || this.state.filterValue) &&
          <div className="component-wrapper no-margins">
            <Card className="card no-padding">
              <div className="label-container">
                <h3 className="card-title">
                  {this.trans("title/deposits-and-withdrawals")}
                </h3>
              </div>
              <div
                className="list-filters-wrapper"
                style={{
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <div className="table-filterer">
                  <TextField
                    autoComplete="off"
                    type="text"
                    style={{ color: "rgb(0, 188, 212)" }}
                    label={this.trans("label-search")}
                    value={this.state.filterValue}
                    onChange={this.setFilterValue}
                    variant="standard"
                    error={false}
                  />
                  {!!this.state.filterValue &&
                    <div className="icon icon-ic-close clear-button clear-button-search" onClick={this.clearFilterValue}></div>
                  }
                  {
                    this.state.searchInProgress &&
                    <div className="search-loader">
                      <CircularProgress size={20} />
                    </div>
                  }
                </div>
              </div>
              <TableComponent
                {...this.props}
                paginator={{
                  name: this.savingsPaymentsPaginatorPath,
                  path: this.props.app.paginator
                }}
                className="listing-table disabled"
                rows={this.getPayments()}
                rowsLength={this.state.savingsPayments?.length}
                subtitle={this.trans("title-no-payments-to-list-without-button")}
                isFetching={this.state.isFetching}
                disabled={(!this.state.isAdmin && this.state.company?.isAgency)}
              />
            </Card>
          </div>
        }
      </div>
    );
  }

  public deletePayment = () => {
    const paymentToDelete: PaymentInterface = this.selectedPayment;
    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_DELETE_START,
      payload: {
        payment: paymentToDelete
      },
      onSuccess: () => {
        this.fetchSavingsPayments(this.state.company?.id)
        this.selectedPayment = null;

        this.setState({
          isSaving: false,
          isPaymentRemovePopupOpen: false
        });
      },
      onError: () => {
        this.selectedPayment = null;

        this.setState({
          isSaving: false,
          isPaymentRemovePopupOpen: false
        });
      }
    });
  }

  public delete = (): any => {
    const agencyFee = this.state.agencyFee;

    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_DELETE_START,
      payload: agencyFee,
      onSuccess: () => {
        this.setState({ isAgencyRemoveDialog: false, agencyFee: null });
      },
      onError: () => {
        this.setState({
          isAgencyRemoveDialog: false,
          agencyFee: null
        });
      }
    });
  }

  public closePrompt(): void {

    this.setState({
      isAgencyRemoveDialog: false,
      isPaymentRemovePopupOpen: false
    })
  }


  public renderSettingsTab = () => {
    const language = this.state.company.generalContact?.languageTypeId === 1 ? 'en-US' : 'nl-NL' || this.props.app?.settings?.agency?.defaultLanguage?.iso

    const actions = [(
      <Button
        key="modal-cancel-btn"
        color="primary"
        onClick={this.closeDialog}
      >
        {this.trans("button-cancel")}
      </Button>
    ),
    (
      <Button
        key="modal-add-btn"
        variant="contained"
        color="primary"
        disabled={this.state.isDisabled || this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
        onClick={this.addSelectedPersonToState}
      >
        {this.trans("button-add")}
      </Button>
    )];
    return (
      <div>
        <div className="component-wrapper no-margins has-margin-top">
          <Card className="card no-padding no-margins has-margin-bottom">
            <div className="label-container">
              <h3 className="card-title">
                {this.trans("section/agencyfee-table-title")}
              </h3>
              <div className="inner-wrapper-section">
                <h4>
                  {this.trans("section/agencyfee-subtitle/defaultfornewunits")}
                </h4>
              </div>
            </div>
            <div>
              {
                <div style={{ padding: "20px 10px 20px 65px", maxWidth: "420px" }}>
                  <Select
                    className={`form-element full-size form-input scroll-to-unitTypeId ${this.state?.assignmentServiceStatus ? "correct-label-position" : ""}`}
                    error={this.getErrorFor("assignmentServiceStatusId")}
                    value={this.state?.assignmentServiceStatus}
                    onChange={this.changeAssignmentServiceStatus}
                    htmlFor="assignmentServiceStatusId"
                    label={this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}
                    name="assignmentServiceStatus"
                    id="assignmentServiceStatus"
                  >
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(2).toLowerCase()}`)}</MenuItem>
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(5).toLowerCase()}`)}</MenuItem>
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(4).toLowerCase()}`)}</MenuItem>
                    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(3).toLowerCase()}`)}</MenuItem>
                  </Select>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", width: "70%", marginRight: "10px" }}>
                      <TextField
                        autoComplete="off"
                        className="full-size scroll-to-fixedFee"
                        type="text"
                        label={this.trans("dialog/agencyfee-field/fixedfee-label")}
                        value={this.state?.fixedFee}
                        onChange={this.changeFixedFeeAmount}
                        variant="standard"
                        error={!!this.getErrorFor("fixedFee")}
                        helperText={this.getErrorFor("fixedFee")}
                      />
                    </div>

                    <Select
                      className="form-input scroll-to-currency correct-label-position"
                      style={{ width: "30%" }}
                      error={this.getErrorFor("currency")}
                      value={this.state.currency}
                      onChange={this.sync.bind(this, this.syncronizers.CURRENCY)}
                      htmlFor="currency"
                      name="currency"
                      id="currency"
                      disabled={true}
                    >
                      {this.getCurrencySelectboxes()}
                    </Select>
                  </div>
                  <div className="hint-styles-dialog" style={{ margin: "0" }}>
                    {this.trans("dialog/agencyfee-info/amount")}
                  </div>

                  <TextField
                    autoComplete="off"
                    className="form-element scroll-to-percentageFee"
                    type="text"
                    label={this.trans("dialog/agencyfee-field/percentagefee-label")}
                    value={this.state?.percentageFee}
                    onChange={this.changePercentageFeeAmount}
                    variant="standard"
                    error={!!this.getErrorFor("percentageFee")}
                    style={{ width: "calc(70% - 7px)" }}
                  />
                  {!!this.getErrorFor("percentageFee") && <div className="component-error-text">{this.getErrorFor("percentageFee")}</div>}
                  <div className="hint-styles-dialog" style={{ margin: "-14px 0 10px 0" }}>
                    {this.trans("dialog/agencyfee-info/percentagefee")}
                  </div>

                  <Select
                    className={`form-element full-size form-input scroll-to-repeat-period ${this.state?.repeatPeriod ? "correct-label-position" : ""}`}
                    error={this.getErrorFor("repeat-period")}
                    value={this.state?.repeatPeriod}
                    onChange={this.changeRepeatPeriod}
                    htmlFor="repeatPeriod"
                    label={this.trans("dialog/defaultchargetemplates-field/period-label")}
                    name="repeatPeriod"
                    id="repeatPeriod"
                  // disabled={this.state?.assignmentServiceStatus === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")}
                  >
                    {this.getRepeatPeriodAgreementSelectboxes(this.state?.assignmentServiceStatus)}
                  </Select>

                  {parseFloat(this.state.percentageFee.replace(",", ".")) > 0 && (
                    <Select
                      className="form-element full-size form-input scroll-to-fixedPlusPercentageMode correct-label-position"
                      error={this.getErrorFor("fixedPlusPercentageMode")}
                      value={this.state?.fixedPlusPercentageMode && this.state?.fixedPlusPercentageMode.id}
                      onChange={this.updateFPPMode}
                      htmlFor="fixedPlusPercentageMode"
                      label={this.trans("dialog/agencyfee-field/fixedpluspercentagemode-label")}
                      name="fixedPlusPercentageMode"
                      id="fixedPlusPercentageMode"
                    >
                      {
                        Object.keys(this.props.globalTypes?.FixedPlusPercentageModes || {}).map((fpp) => {
                          let fpps = this.props.globalTypes?.FixedPlusPercentageModes?.[fpp];

                          return (
                            <MenuItem key={fpps.id} value={fpps.id}>{this.formatter.checkTranslationType(this.trans(fpps.label), fpps.label)}</MenuItem>
                          );
                        })
                      }
                    </Select>
                  )}
                </div>
              }

            </div>
          </Card>
        </div>
        <div className="component-wrapper no-margins has-margin-top">
          <Card className="card">
            <div className="label-container">
              <h3 className="card-title">
                {this.trans("settings/agencyprofile-info/invoices")}
              </h3>
            </div>
            <div className="component-wrapper no-margins has-margin-bottom">
              <div style={{ padding: "20px 10px 20px 65px", maxWidth: "420px" }}>
                <div>
                  <TextField
                    defaultValue={this.state.company.invoiceEmailAddress || this.state.company.generalContact?.email || ''}
                    className="form-element full-width scroll-to-email"
                    label={this.trans("label-email-address")}
                    type="email"
                    autoComplete="email"
                    fullWidth={true}
                    onChange={(e) => this.setState({ invoiceEmailAddress: e.target.value, hasModifiedData: true })}
                    variant="standard"
                    disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                    error={!!this.props.component.message}
                  />
                  <div className="info-text hint-styles hint-styles-closer" style={{ marginBottom: "10px" }}>
                    {this.trans("settings/agencyprofile-info/invoices-hint")}
                  </div>
                </div>
                <TextField
                  defaultValue={this.state.company.invoiceEmailSubject || `${this.trans('invoice', {}, language)} ${this.state.company.name}`}
                  className="form-element full-width scroll-to-email"
                  label={this.trans("settings-email-subject")}
                  type="text"
                  fullWidth={true}
                  onChange={(e) => this.setState({ invoiceEmailSubject: e.target.value, hasModifiedData: true })}
                  variant="standard"
                  disabled={this.state.removed || (!this.state.isAdmin && this.state.company?.isAgency)}
                  error={!!this.props.component.message}
                />
              </div>
            </div>
          </Card>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("person-pick")}
          innerDialogClasses="person-pick"
          content={
            <div>
              <PersonLookup
                {...this.props}
                autoFocus={false}
                autoSelectId={this.selectedPerson ? this.selectedPerson.id : null}
                isInlineBlock={true}
                width="100%"
                containerWidth="100%"
                ref="PersonLookup"
                onSelect={this.addSelectedPersonToCache}
                onClear={this.removeSelectedPersonFromCache}
                hideClickThroughLink={true}
                forceUpdatePage={true}
                saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "companyUpdate")}
                filterOutEntities={this.state.company && this.state.company.persons}
                styleInModal={"styleInModal"}
              />
            </div>
          }
          openLeavePrompt={this.state.isDialogOpen}
          onClose={this.closeDialog}
          onlyPositiveButton={true}
          crossButtonClose={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          actions={actions}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("person-pick")}
          innerDialogClasses="person-pick"
          content={
            <div>
              <PersonLookup
                {...this.props}
                autoFocus={false}
                autoSelectId={this.selectedPerson ? this.selectedPerson.id : null}
                isInlineBlock={true}
                width="100%"
                containerWidth="100%"
                ref="PersonLookup"
                onSelect={this.addSelectedPersonToCache}
                onClear={this.removeSelectedPersonFromCache}
                hideClickThroughLink={true}
                forceUpdatePage={true}
                saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "companyUpdate")}
                filterOutEntities={this.state.company && this.state.company.persons}
                styleInModal={"styleInModal"}
              />
            </div>
          }
          openLeavePrompt={this.state.isDialogOpen}
          onClose={this.closeDialog}
          onlyPositiveButton={true}
          crossButtonClose={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          actions={actions}
        />
      </div>
    );
  }

  public changeFixedFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    if (this.state?.agreementVat) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state?.vat)).replace(",", ".")).toFixed(2));
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      let vatPercentage = vatNumber / (fixedFee - vatNumber) * 100;

      return this.setState({
        vatPercentage: isFinite(vatPercentage) ? this.formatter.simpleFormatNumber(Math.round(vatPercentage), false, false) : "",
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    if (this.state?.vatPercentage) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state?.vatPercentage)).replace(",", ".")).toFixed(2));
      vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

      const vatNumber = fixedFee / (100 + vatPercentageNumber) * vatPercentageNumber;

      return this.setState({
        agreementVat: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    return this.setState({
      agreementVat: "",
      vatPercentage: "",
      fixedFee: amount,
      hasModifiedData: true
    });
  }

  public changePercentageFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      percentageFee: amount,
      hasModifiedData: true
    });
  }

  public changeAssignmentServiceStatus = (event) => {
    const type: number = event.target.value;
    this.clearBackEndErrors();

    this.setState({
      assignmentServiceStatus: type,
      repeatPeriod: type === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
      hasModifiedData: true
    });
  }

  public changeRepeatPeriod = (event) => {
    const period: number = event.target.value;
    this.clearBackEndErrors();

    this.setState({
      repeatPeriod: period,
      hasModifiedData: true
    });
  }

  public updateFPPMode = (event) => {
    const fpp = this.props.globalTypes?.FixedPlusPercentageModes?.[event.target.value];

    this.setState({
      fixedPlusPercentageMode: fpp,
      hasModifiedData: true
    });
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public switchTab = (_event, tabValue): any => {
    this.setState({
      selectedTabIndex: tabValue
    });

    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_SWITCH_TAB,
      payload: {
        index: tabValue,
        companyId: this.state.company?.id
      }
    });

    this.fetchSavingsPayments(this.state.company?.id);
  }

  public redirectBackModify = (company) => {
    if (!company) {
      company = this.state.company
    }

    if (this.state.сreateFromCoach) {
      const savedDataBeforeRedirecting = { ...this.props.app.savedDataBeforeRedirecting };

      savedDataBeforeRedirecting.propertyCreateDataToBeSaved = this.state.propertyCreateDataToBeSaved;
      savedDataBeforeRedirecting.propertyCreateDataToBeSaved.selectedCompany = company;

      this.props.dispatch({
        type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
        payload: {
          savedDataBeforeRedirecting: { ...savedDataBeforeRedirecting }
        }
      });
    }

    return this.redirectBack();
  }

  /* START Methods for 3-dot menu */

  protected openCompanyMenu = (event: any): void => {
    this.setState({
      anchorCompanyEl: event.currentTarget
    });
  }

  protected closeCompanyMenu = (): void => {
    this.setState({
      anchorCompanyEl: null
    });
  }

  protected openDeletePromptDialog = (entity: any): void => {
    this.setState({
      isDeletePromptOpen: true,
      entity: entity,
      anchorCompanyEl: null
    });
  }

  public closeDeletePrompt = (): void => {
    this.setState({
      isDeletePromptOpen: false,
      anchorCompanyEl: null
    });
  }

  public deleteCompany = () => {
    this.closeDeletePrompt();

    return this.props.dispatch({
      type: Constants.GLOBAL_COMPANY_DELETE_START,
      payload: {
        company: this.state.company
      },
      onSuccess: () => {
        this.redirectBack();
      }
    });
  }


  protected openDownloadPromptDialog = (entity: any): void => {
    this.setState({
      isDownloadPromptOpen: true,
      entity: entity,
      anchorCompanyEl: null
    });
  }

  public closeDownloadPromptDialog = (): void => {
    this.setState({
      isDownloadPromptOpen: false,
      anchorCompanyEl: null
    });
  }
  /* FINISH Methods for 3-dot menu */

  public renderTitle = () => {
    // if (this.state.company && this.state.company?.isOwner) {
    //   return this.trans("title-owner") + " "
    // } else if (this.state.company && this.state.company?.isAgency) {
    //   return this.trans("title-agency") + " "
    // } else {
    //   return this.trans("title-company") + " "
    // }

    return this.trans(`title-${this.state.company?.companyType}`) + " "
  }

  public depositToSavingAccount = () => {
    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_START,
      payload: {
        ownerId: this.state?.company?.id,
        amount: parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.amountDeposit)).replace(",", ".")).toFixed(2))
      },
      onSuccess: () => {
        this.setState({
          isSaving: false,
          openDepositDialog: false,
          amountDeposit: ""
        });

        this.fetchSavingsPayments(this.state.company?.id);
        this.clearBackEndErrorDeposit();
      },
      onError: () => {
        this.setState({
          isSaving: false,
        });
      }
    });
  }

  public changeAgencyBankAccountForWithdrawal = (event): void => {
    const bankAccountId: number = event.target.value;
    if (bankAccountId) {
      this.setState({
        bankAccountId: bankAccountId,
      });
    }
  }

  public changeAmountDeposit = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    return this.setState({
      amountDeposit: amount
    });
  }

  public setDefaltValueForWithdrawalDialog = () => {
    this.setState({
      bankAccountId: this.state.agencyBankAccounts.find(bankAccount => bankAccount.accountId === this.state.company?.mainBankAccountId)?.id || "",
      amountWithdrawal: this.state.company?.savingsAccount && Math.sign(this.state.company?.savingsAccount) !== -1 ? Formatter.simpleFormatNumber(this.state.company?.savingsAccount) : ""
    })
  }

  public renderDepositContent = () => {
    return (
      <div>
        <div className="hint-styles-dialog">{this.trans("dialog/preprocess-info/deposit")}</div>
        <TextField
          autoComplete="off"
          className="form-element full-size scroll-to-amount"
          type="text"
          label={this.trans("label-amount")}
          value={this.state.amountDeposit}
          onChange={this.changeAmountDeposit}
          variant="standard"
          autoFocus={!!this.props.autoFocusAmount}
          error={!!this.getErrorFor("amount")}
        />
        {!!this.getErrorFor("amount") && <div className="component-error-text">{this.getErrorFor("amount")}</div>}
      </div>
    );
  }

  public clearBackEndErrorDeposit = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_CLEAR_ERROR
    });
  }

  public openChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: true
    });
  }

  public closeChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: false
    });
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={() => { this.redirectBackModify(this.state.company) }}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.renderTitle()}{this.state?.company?.displayName}</h1>
              <div className="button-container-small">
                {
                  this.state.hasModifiedData && (
                    <Button
                      color="primary"
                      onClick={() => { this.redirectBackModify(this.state.company) }}
                      style={{ marginRight: "20px" }}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                  )
                }
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.state.hasModifiedData ? this.save : this.done}
                  disabled={this.state.isSaving}
                >
                  {this.state.hasModifiedData ? this.trans("button-save") : this.trans("label-done")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-company-update">
            <div className="component-wrapper no-margin-top no-shadow">
              <div style={{ position: "relative" }}>
                <Tabs
                  className={(this.state.company?.isOwner || this.state.company?.isAgency) ?
                    "tab tab-simple tab-contains-3 half-size has-margin-bottom" :
                    "tab tab-simple tab-contains-2 half-size has-margin-bottom"}
                  value={this.state.selectedTabIndex}
                  onChange={this.switchTab}
                >
                  <Tab
                    label={this.trans("label-overview")}
                    value={Constants.COMPANY_DETAILS_OVERVIEW_TAB}
                  />
                  {
                    (this.state.company?.isOwner || this.state.company?.isAgency) && (
                      <Tab
                        label={this.trans("title-charges")}
                        value={Constants.COMPANY_DETAILS_CHARGES_TAB}
                      />
                    )
                  }
                  {
                    this.state.company?.isOwner && (
                      <Tab
                        label={this.trans("title-invoices")}
                        value={Constants.COMPANY_DETAILS_INVOICES_TAB}
                      />
                    )
                  }
                  {
                    (this.state.company?.isOwner || this.state.company?.isAgency) && (
                      <Tab
                        label={this.trans("title-statements")}
                        value={Constants.COMPANY_DETAILS_STATEMENTS_TAB}
                      />
                    )
                  }
                  {
                    (this.state.company?.isOwner || this.state.company?.isAgency) && (
                      <Tab
                        label={this.trans("title-savings")}
                        value={Constants.COMPANY_DETAILS_SAVINGS_TAB}
                      />
                    )
                  }
                  {
                    this.state.company?.isOwner && (
                      <Tab
                        style={{ marginLeft: "auto", padding: "0 10px" }}
                        label={this.trans("label-settings")}
                        value={Constants.COMPANY_DETAILS_SETTINGS_TAB}
                      />
                    )
                  }
                </Tabs>
              </div>
              {this.state.selectedTabIndex === Constants.COMPANY_DETAILS_OVERVIEW_TAB && this.renderCompanyInfoTab()}
              {(this.state.company?.isOwner || this.state.company?.isAgency) && this.state.selectedTabIndex === Constants.COMPANY_DETAILS_CHARGES_TAB && this.renderChargesTab()}
              {(this.state.company?.isOwner || this.state.company?.isAgency) && this.state.selectedTabIndex === Constants.COMPANY_DETAILS_INVOICES_TAB && this.renderInvoicesTab()}
              {(this.state.company?.isOwner || this.state.company?.isAgency) && this.state.selectedTabIndex === Constants.COMPANY_DETAILS_STATEMENTS_TAB && this.renderStatementsTab()}
              {(this.state.company?.isOwner || this.state.company?.isAgency) && this.state.selectedTabIndex === Constants.COMPANY_DETAILS_SAVINGS_TAB && this.renderSavingsTab()}
              {this.state.company?.isOwner && this.state.selectedTabIndex === Constants.COMPANY_DETAILS_SETTINGS_TAB && this.renderSettingsTab()}
            </div>
          </div>

          {!this.state.removed && (
            <div className={"right-panel-wrapper"}>
              <EntityLaunchpanel
                {...this.props}
                entityTitle={this.trans("launchpanel-company-title")}
                actionsList={
                  <List component="div" disablePadding>
                    {
                      !this.state.company?.isAgency && (
                        <ListItem
                          button
                          key={"add-contact"}
                          alignItems="flex-start"
                          onClick={this.openTabDialog}
                          style={{ padding: "1px 16px" }}
                        >
                          <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-person"></div></ListItemIcon>
                          <ListItemText primary={this.trans("launchpanel-link/addcontactforcompany")} secondary={this.trans("launchpanel-hint/addcontactforcompany")} />
                        </ListItem>
                      )
                    }
                    {
                      !this.state.сreateFromCoach && !this.state?.company?.isAgency && (
                        <ListItem
                          button
                          key={"add-property"}
                          alignItems="flex-start"
                          onClick={() => this.setState({
                            openCoachCreateNewUnit: true
                          })}
                          style={{ padding: "1px 16px" }}
                        >
                          <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-property"></div></ListItemIcon>
                          <ListItemText primary={this.trans("launchpanel-link/addpropertyforcompany")} secondary={this.trans("launchpanel-hint/addpropertyforcompany")} />
                        </ListItem>
                      )
                    }
                    <ListItem
                      button
                      key={"remove_company"}
                      alignItems="flex-start"
                      onClick={this.openDeletePromptDialog}
                      style={{ padding: "1px 16px" }}
                    >
                      <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-remove"></div></ListItemIcon>
                      <ListItemText primary={this.trans("menuitem-delete-company")} secondary={this.trans("launchpanel-hint/deletecompany")} />
                    </ListItem>
                    <ListItem
                      button
                      key={"download_xlsx"}
                      alignItems="flex-start"
                      onClick={this.openDownloadPromptDialog}
                      style={{ padding: "1px 16px" }}
                    >
                      <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-download"></div></ListItemIcon>
                      <ListItemText primary={this.trans("menuitem-download-csv")} secondary={this.trans("launchpanel/download-csv-file")} />
                      </ListItem>
                  </List>
                }
              />

              {
                this.isBeta() &&
                <Timeline
                  {...this.props}
                  relations={{ companyId: this.state.company && this.state.company.id }}
                  entityEvents={this.state.events}
                  fetchEntityEvents={this.fetchEntityEvents.bind(this, this.state.company && this.state.company.id)}
                  fetchingEvents={this.state.fetchingEvents}
                />
              }
            </div>
          )}
        </div>

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'agency-fee-remove-from-settings-page'}
          isOpen={this.state.isAgencyRemoveDialog}
          onCancel={this.closePrompt}
          onDelete={this.delete}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'contact-company-remove-dialog'}
          isOpen={this.state.isDeletePromptOpen}
          onCancel={this.closeDeletePrompt}
          onDelete={this.deleteCompany}
        />

        <DownloadEntityPrompt
          {...this.props}
          isOpen={this.state.isDownloadPromptOpen}
          onCancel={this.closeDownloadPromptDialog}
          selectedYear={this.state.selectedYear}
          ownerId={this.state.company?.id}
          lng={this.props.app?.settings?.agency?.defaultLocale?.iso}
          userlng={this.props.app?.settings?.user?.language?.iso}
        />
        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={
            <div>
              <span>{this.trans("title-remove-savings-payment-warning")}</span>
            </div>}
          openLeavePrompt={this.state.cannotDeleteSavingsChargeDialog}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({ cannotDeleteSavingsChargeDialog: false })}
          onlyPositiveButton={true}
        />

        <SavingsCompanyDialog
          {...this.props}
          entity={this.state.company}
          isOpen={this.state.openSavingsDialog}
          savingsType={this.state.savingsType}
          amountWithdrawal={this.state.amountWithdrawal}

          initializePage={() => {
            this.fetchSavingsPayments(this.state.company?.id);
            this.setDefaltValueForWithdrawalDialog();
          }}
          closeDialog={() => this.setState({ openSavingsDialog: false })}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.openDepositDialog}
          title={this.trans("dialog/preprocess-deposit/title")}
          content={this.renderDepositContent()}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={this.depositToSavingAccount}
          onDiscard={() => this.setState({ openDepositDialog: false, amountDeposit: "" }, this.clearBackEndErrorDeposit)}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"title-payment-delete-from-payment-page-content-dialog"}
          isOpen={this.state.isPaymentRemovePopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.deletePayment}
        />

        <UndoSettleWithSavingsDialog
          {...this.props}
          entity={this.selectedPayment}
          isOpen={this.state.isUndoSavingsPopupOpen}

          initializePage={() => {
            this.fetchSavingsPayments(this.state.company?.id)
          }}
          closeDialog={() => this.setState({ isUndoSavingsPopupOpen: false, anchorEl: null })}
        />

        <ChargeCreateDialog
          isOpened={this.state.isChargeCreatePopupOpen}
          title={this.trans("title-new-charge")}
          selectedEntity={this.state.company}
          onCancel={this.closeChargeCreatePopup}
          {...this.props}
        />

        {this.state.isCoachNewChargeOpen && (
          <CoachNewCharge
            {...this.props}
            openCoach={this.state.isCoachNewChargeOpen}
            selectedObjectForNewCharge={this.state.company}
            onCloseCoach={(success: boolean = false, charge) => {
              this.setState({
                isCoachNewChargeOpen: false
              }, () => {
                if (success) {
                  return this.redirect(`/app/charge/update/${charge.id}`)
                }
              })
            }}
            selectedOwnerForNewCharge={this.state?.company || null}
            // defaultChargeTypeId={TypeContainer.pickIdFromLabel("Other_receivable")}
            // defaultChargeTypeLabel={"Other_receivable"}
          />
        )}

        {this.state.openCoachCreateNewUnit && (
          <CoachNewUnitDialog
            {...this.props}
            openCoachCreateNewUnit={this.state.openCoachCreateNewUnit}
            notRedirectAfterFinish={true}
            onCloseUnitCoach={(unit) => {
              this.setState({
                openCoachCreateNewUnit: false
              })
              if (unit) {
                return this.redirect(`/app/unit/update/${unit?.id}`);
              }
            }}
            company={this.state.company}
            activeStep={1}
          />
        )}

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    component: state.companyUpdate,
    globalTypes: state.globalTypes,
  };
};

export default connect(mapStateToProps)(
  CompanyUpdate
);
